__turbopack_context__.v({
  "contributor": "tA4svW_contributor",
  "contributor__additional": "tA4svW_contributor__additional",
  "contributor__email": "tA4svW_contributor__email",
  "contributor__image": "tA4svW_contributor__image",
  "contributor__subrole": "tA4svW_contributor__subrole",
  "contributor__title": "tA4svW_contributor__title",
});
